
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLineOfPosition as ObiLineOfPositionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-line-of-position.js';
 
 
 

 
 export const ObiLineOfPosition = createComponent({
   react: React,
   tagName: 'obi-line-of-position',
   elementClass: ObiLineOfPositionElement,
   events: {
     
   }
  });
 
 